module.exports = __webpack_public_path__ + "bluemedia.png";